import { defineComponent as _defineComponent } from 'vue'
import { computed, inject } from 'vue';
    import Error from '../types/Error.ts';
    import { ErrorZone } from '../types/enums.ts';
    import { MainStore } from '../../../store.ts'
    import Alert from '../../../components/alert.vue';

    interface Props {
        error_zone: ErrorZone
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'error_zone',
  props: {
    error_zone: { type: Number, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

    const store: MainStore = inject('store') as MainStore

    const props = __props
    const prop_error_zone = computed(() => props.error_zone )
    const sto_errors = computed(() => store.errors)

    const com_errors_in_zone = computed(() => {
        const loc_error_zone = prop_error_zone.value
        const loc_errors = sto_errors.value
        return loc_errors.filter((tmp_error: Error) => {
            return tmp_error.error_zone === loc_error_zone
        })
    })

const __returned__ = { store, props, prop_error_zone, sto_errors, com_errors_in_zone, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})